import request from '@/router/axios';

/** 仓储布局优化建议看板 */
export const getWarehouseLayoutOptimization = (params) => {
  return request({
    url: '/api/produce/kanban/warehouse-layout-optimization',
    method: 'get',
    params: params || {},
  });
};

/** 客户下拉 */
export const getCustomerOptions = (params) => {
  return request({
    url: '/api/produce/blade-dept/select/distinct/select',
    method: 'get',
    params: params || {},
  });
};

/** 物资下拉 */
export const getCargoOptions = (params) => {
  return request({
    url: '/api/produce/vardict/select/distinct/pycode',
    method: 'get',
    params: params || {},
  });
};
